/* tslint:disable */
/* eslint-disable */
/**
 * EH Commissioning WebAPI 1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SyncError
 */
export interface SyncError {
  /**
   *
   * @type {string}
   * @memberof SyncError
   */
  message?: string | null;
}

export function SyncErrorFromJSON(json: any): SyncError {
  return SyncErrorFromJSONTyped(json, false);
}

export function SyncErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): SyncError {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    message: !exists(json, "message") ? undefined : json["message"],
  };
}

export function SyncErrorToJSON(value?: SyncError | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    message: value.message,
  };
}
